"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ModuleItemFilter = (0, vue_1.resolveComponent)("ModuleItemFilter");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_ModuleItemFilter, {
        title: "Colonies",
        groups: _ctx.GROUPS,
        itemsByGroup: _ctx.ITEMS_BY_GROUP,
        selected: _ctx.initialSelected,
        "onUpdate:selected": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('colonies-list-changed', $event))),
        onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
    }, {
        item: (0, vue_1.withCtx)(({ itemName, icon }) => [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(itemName) + " - (" + (0, vue_1.toDisplayString)(_ctx.COLONY_DESCRIPTIONS[itemName]) + ")", 1)
            ])), [
                [_directive_i18n]
            ]),
            (_ctx.compatibility(itemName))
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                    key: 0,
                    class: (0, vue_1.normalizeClass)(icon(_ctx.compatibility(itemName)))
                }, null, 2))
                : (0, vue_1.createCommentVNode)("", true)
        ]),
        _: 1
    }, 8, ["groups", "itemsByGroup", "selected"]));
}
